/**
 * Роли и права. Роль выдаётся конкретному Telegram ID в конфигурации gateway —
 * никакой «регистрации» в приложении нет и быть не может.
 */
export const ROLES = ['owner', 'manager', 'viewer'];
export const PERMISSIONS = [
    'orders:read',
    'orders:write',
    'orders:create',
    'customers:read',
    'customers:write',
    'finance:read',
    'finance:write',
    'payments:write',
    'settings:write',
];
const VIEWER = ['orders:read', 'customers:read'];
const MANAGER = [
    ...VIEWER,
    'orders:write',
    'orders:create',
    'customers:write',
    'finance:read',
    'payments:write',
];
const OWNER = [...MANAGER, 'finance:write', 'settings:write'];
export const ROLE_PERMISSIONS = {
    owner: OWNER,
    manager: MANAGER,
    viewer: VIEWER,
};
export function roleHas(role, permission) {
    return ROLE_PERMISSIONS[role].includes(permission);
}
export function isRole(value) {
    return typeof value === 'string' && ROLES.includes(value);
}
//# sourceMappingURL=access.js.map